export class Organization {
    id: string = null;
    usaagoPosition: number = null;
    usaagoOrganizationName: string = null;
    maxAmountOfActiveUsers: number = null;
    organizationEmailDomain: string = null;

    constructor(organizationShape?: Partial<Organization>) {
        if (organizationShape != null) {
            if (organizationShape.id != null) {
                this.id = organizationShape.id;
            }

            if (organizationShape.usaagoPosition != null) {
                this.usaagoPosition = organizationShape.usaagoPosition;
            }

            if (organizationShape.usaagoOrganizationName != null) {
                this.usaagoOrganizationName = organizationShape.usaagoOrganizationName;
            }

            if (organizationShape.maxAmountOfActiveUsers != null) {
                this.maxAmountOfActiveUsers = organizationShape.maxAmountOfActiveUsers;
            }

            if (organizationShape.organizationEmailDomain != null) {
                this.organizationEmailDomain = organizationShape.organizationEmailDomain;
            }
        }
    }
}
